




























import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      menu: false
    }
  },
  mounted() {
    if (this.$store.state.titleItems && this.$store.state.titleItems.action) {
      this.$store.state.titleItems.action();
    }
  },
  methods: {
    activate(item: any) {
      this.menu = false;
      this.$router.push(`/clients/${item.id}`)
    },
    initItems() {
      if (this.$store.state.titleItems.action) {
        this.$store.state.titleItems.action();
      }
    }
  },
  computed: {
    show(): boolean {
      return this.$store.state.titleItems;
    },
    items(): any[] | null { 
      return this.$store.state.titleItems.items.filter((x: any) => x.name !== this.$store.state.client.name);
    }
  }
});
